// extracted by mini-css-extract-plugin
module.exports = {"image":"BannerImage_image__yPQJO"};